// TruCheck™ Fraud Classification Taxonomy (multi-select) for the Internal Investigations section.
// Mirrors the backend list (shared-lib helper/pre-check/fraud-types) — the backend rejects unknown values.
export const FRAUD_TYPE_GROUPS = [
    {
        label: "Identity & Document Fraud",
        types: [
            {
                value: "dl_state_id_fraud",
                label: "DL / State ID Fraud",
                description: "Counterfeit, altered, or synthetic Driver's License / State ID"
            },
            {
                value: "green_card_lpr_fraud",
                label: "Green Card / LPR Fraud",
                description: "Fabricated or altered Permanent Resident Card Form I-551"
            },
            {
                value: "ead_card_fraud",
                label: "EAD Card Fraud",
                description: "Fabricated or altered Employment Authorization Document Form I-766"
            },
            {
                value: "passport_fraud",
                label: "Passport Fraud",
                description: "Counterfeit, altered, or mismatched foreign/US passport"
            },
            {
                value: "form_i94_fraud",
                label: "Form I-94 / Arrival-Departure Record Fraud",
                description: "Forged, altered, or expired I-94 travel history"
            },
            {
                value: "ssn_tax_id_fraud",
                label: "SSN / Tax ID Fraud",
                description: "Synthetic SSN, stolen SSN, or invalid SSN formatting"
            },
            {
                value: "synthetic_identity_creation",
                label: "Synthetic Identity Creation",
                description: "Combining real PII from data breaches with fabricated documents"
            }
        ]
    },
    {
        label: "Immigration & Work Authorization Fraud",
        types: [
            {
                value: "h1b_credential_fraud",
                label: "H-1B Credential / Specialty Occupation Fraud",
                description: "Forged H-1B approval notices, fake petitioning employers"
            },
            {
                value: "nonimmigrant_visa_fraud",
                label: "L-1 / O-1 / TN / Visa Stamp Fraud",
                description: "Falsified non-immigrant visa credentials"
            },
            {
                value: "work_authorization_expired_unauthorized",
                label: "Work Authorization Expired / Unauthorized",
                description: "Working without valid US employment eligibility"
            }
        ]
    },
    {
        label: "Biometric & Live Screening Fraud",
        types: [
            {
                value: "biometric_liveness_failure_spoofing",
                label: "Biometric Liveness Failure / Spoofing",
                description: "Static image injection, pre-recorded video, deepfake"
            },
            {
                value: "photo_to_id_discrepancy",
                label: "Photo-to-ID Discrepancy",
                description: "Live selfie face does not match document photo"
            },
            {
                value: "proxy_impersonation",
                label: "Proxy / Impersonation",
                description: "A different individual completing the verification session on behalf of the candidate"
            }
        ]
    },
    {
        label: "Operational & Remote Work Fraud",
        types: [
            {
                value: "proxy_interviewing_screening",
                label: "Proxy Interviewing / Proxy Screening",
                description: "Third party conducting candidate interviews or technical assessments"
            },
            {
                value: "mule_worker_credential_renting",
                label: "Mule Worker / Credential Renting",
                description: "Renting/leasing another individual's identity or work authorization for employment"
            },
            {
                value: "it_asset_device_spoofing",
                label: "IT Asset / Device Spoofing",
                description: "VPN evasion, rogue IP/geolocation masking, unauthorized remote desktop"
            }
        ]
    },
    {
        label: "High-Risk / Sanctions / State-Sponsored Threat",
        types: [
            {
                value: "dprk_it_worker_fraud",
                label: "DPRK / IT Worker Fraud",
                description: "North Korean state-sponsored remote worker scheme"
            },
            {
                value: "sanctions_pep_watchlist_match",
                label: "Sanctions / PEP / Watchlist Match",
                description: "Matches against OFAC, BIS, or international law enforcement databases"
            }
        ]
    }
]

const FRAUD_TYPE_LABELS = Object.fromEntries(
    FRAUD_TYPE_GROUPS.flatMap((group) => group.types.map((type) => [type.value, type.label])),
)

// Unknown values (e.g. a type later renamed) fall back to the stored value.
export const fraudTypeLabel = (value) => FRAUD_TYPE_LABELS[value] || value
